<template lang="pug">
  div
    toolbar.mb-4.mb-lg-5
    b-container
      b-button.mb-3(variant="soft-secondary", :to="{name: 'Learn'}")
        arrow-left-icon.icon-sm.mr-2.mb-1
        span Regresar
      b-list-group
        b-list-group-item(v-for="video in videos", :key="video.id", href="#", @click="selectedVideo=video;openVideo=true;")
          b-row.align-items-center.justify-content-center
            b-col.mb-3.mb-md-0(cols="auto")
              .video-container
                b-img(:src="`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`", rounded, thumbnail)
                play-circle-icon(style="position:absolute;bottom:15px;right:15px;")
            b-col(cols="12", md)
              h5 {{video.name}}
              p.mb-0.text-secondary {{video.description}}
              p.mb-0.text-help.text-sm Duración {{video.duration}}
    b-modal(ok-only, ok-title="Cerrar", ok-variant="secondary", v-model="openVideo", @close="selectedVideo = null;", size="lg", :title="selectedVideo ? selectedVideo.name : ''")
      b-embed(type="iframe", aspect="16by9", :src="`https://www.youtube.com/embed/${selectedVideo.id}`", allowfullscreen, v-if="selectedVideo != undefined")
</template>

<script>
import Toolbar from '@/components/Toolbar.vue'
export default {
  components: {
    Toolbar
  },
  data () {
    return {
      openVideo: false,
      selectedVideo: null,
      videos: [
        {
          id: 'od1LQeJQv2w',
          name: '¿Cómo crear un Chatbot?',
          description: 'Aprende a crear un Chatbot para tu cliente y su configuración inicial para que quede listo y productivo.',
          duration: '1:56 mins'
        },
        {
          id: 'PVUnruJSBZA',
          name: '¿Cómo crear un acceso para mi cliente?',
          description: 'Aprende a crear una cuenta de acceso al panel de control para tus clientes.',
          duration: '1:21 mins'
        },
        {
          id: 'AE5BA2x1Sf8',
          name: '¿Cómo entrenar un Chatbot?',
          description: 'Aprende a programar preguntas frecuentes que contestará el Chatbot de tu cliente. Solo agrega la pregunta y cómo debe contestar.',
          duration: '1:21 mins'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  .video-container {
    position: relative;
    width: 200px;
    max-width: 100%;
    padding-top: 55%;

    img {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      max-width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
</style>